import React from "react"
import useInsuranceDetails from "../context/useInsuranceDetails"
import { CMDTableContainer } from "#/components/views/reimbursements/educationmodal/CMDTable"
import { FormattedMessage } from "react-intl"
import { Typography, Stack } from "@carrotfertility/carotene-core"
import {
  COMPANY_DEDUCTIBLE_STATUS,
  CMD_CONFIGURATION,
  useUserDeductible
} from "#/components/context/user/DeductibleContext"
import { DeductibleInfoMessage } from "#/components/views/reimbursements/educationmodal/DeductibleInfoMessage"

interface DeductibleTitleProps {
  cmdConfiguration: string
}

const DeductibleTitle = ({ cmdConfiguration }: DeductibleTitleProps): JSX.Element => {
  return cmdConfiguration === CMD_CONFIGURATION.MEMBER_AND_PARTNER_SEPARATE ? (
    <Typography variant="h2">
      <FormattedMessage defaultMessage="Deductibles" />
    </Typography>
  ) : (
    <Typography variant="h2">
      <FormattedMessage defaultMessage="Deductible" />
    </Typography>
  )
}

const DeductibleTables = (): JSX.Element => {
  return (
    <>
      <CMDTableContainer />
    </>
  )
}

export const DeductiblesSection = (): JSX.Element => {
  const { companyDeductibleStatus, insuranceExpired } = useInsuranceDetails()
  const { cmdConfiguration } = useUserDeductible()

  return (
    companyDeductibleStatus !== COMPANY_DEDUCTIBLE_STATUS.EXTERNAL &&
    !insuranceExpired && (
      <Stack gap={(theme) => theme.tokens.spacing.lg}>
        <Stack marginTop={(theme) => theme.spacing(theme.tokens.spacing.xxl)}>
          <DeductibleTitle cmdConfiguration={cmdConfiguration} />
        </Stack>
        <DeductibleInfoMessage />
        {companyDeductibleStatus !== COMPANY_DEDUCTIBLE_STATUS.NO_DEDUCTIBLE && <DeductibleTables />}
      </Stack>
    )
  )
}
